import { OrderTypes } from '../view/basicorderinfo/Types';

export function isPhotoOrder(orderType: number): boolean {
    return (orderType & OrderTypes.photo) !== 0;
}

export function isStylingOrder(orderType: number): boolean {
    return (orderType & OrderTypes.styling) !== 0;
}

export function isDigitalStylingOrder(orderType: number): boolean {
    return (orderType & OrderTypes.digitalStyling) !== 0;
}
